// extracted by mini-css-extract-plugin
export default {"list":"history_list__woUAb","entry":"history_entry__rKydb","first":"history_first__7GGUt"};